import React, { useEffect, useState } from "react";
import CustomTable from "../CustomTable";
import Button from "../../atoms/Button";
import { calcFund } from "../../../utils/helper/calcTotalFundRequired";
import { formatBalance } from "../../../utils/helper/wallet";

import Input from "../../atoms/Input";

const Bid = ({
  location,
  bidPrice,
  numberOfCredits,
  onCreditsChange,
  onBidPriceChange,
  totalCredits,
  isRequreIncreseDecreaseButton = false,
  orderPayments = false,
  amount,
  gst,
  platformFee,
  remittance,
  totalAmount,
}) => {

  const updatedBidSchema = [
    {
      "Project Name": location,
      "Number Of Credits": (
        <div className="flex items-center justify-center">
          {!isRequreIncreseDecreaseButton && (
            <Button
              variant="secondary"
              borderColor="blue"
              className="flex items-center justify-center w-[16px] h-[16px] px-1 py-0 border-none text-blue-800 bg-blue-100"
              onClick={() => {
                if (numberOfCredits > 1) onCreditsChange(numberOfCredits - 1);
              }}
            >
              -
            </Button>
          )}
          <span className="text-[13px] font-normal px-5">
            <Input
              type="number"
              value={numberOfCredits}
              className="w-20"
              onChange={(e) => {
                let value = parseInt(e.target.value || 0);
                if (e.target.value === "") onCreditsChange("");
                else if (value >= 0)
                  onCreditsChange(Math.min(value, totalCredits));
              }}
              disabled={isRequreIncreseDecreaseButton}
            />
          </span>
          {!isRequreIncreseDecreaseButton && (
            <Button
              variant="secondary"
              borderColor="blue"
              className="flex items-center justify-center w-[16px] h-[16px] py-0 border-none text-blue-800 bg-blue-100"
              onClick={() => {
                if (numberOfCredits < totalCredits)
                  onCreditsChange(numberOfCredits + 1);
              }}
            >
              +
            </Button>
          )}
        </div>
      ),
      "Bid Price": (
        <div className="flex items-center justify-center">
          {!isRequreIncreseDecreaseButton && (
            <Button
              variant="secondary"
              borderColor="blue"
              className="flex items-center justify-center w-[16px] h-[16px] px-1 py-0 border-none text-blue-800 bg-blue-100"
              onClick={() => {
                if (bidPrice > 1) onBidPriceChange(Number(bidPrice) - 1);
              }}
            >
              -
            </Button>
          )}
          <span className="px-5 flex">
            {"$ "}
            <Input
              type={"number"}
              value={bidPrice}
              className={"w-20 ml-1"}
              onChange={(e) => {
                let value = Number(e.target.value || 0);
                if (e.target.value === "") onBidPriceChange("");
                else if (value >= 0) onBidPriceChange(value);
              }}
              disabled={isRequreIncreseDecreaseButton}
            />
          </span>
          {!isRequreIncreseDecreaseButton && (
            <Button
              variant="secondary"
              borderColor="blue"
              className="flex items-center justify-center w-[16px] h-[16px] px-1 py-0 border-none text-blue-800 bg-blue-100"
              onClick={() => {
                onBidPriceChange(Number(bidPrice) + 1);
              }}
            >
              +
            </Button>
          )}
        </div>
      ),
      "Total Price": `$${(numberOfCredits * bidPrice)?.toFixed(2)}`,
    },
  ];

  const headerDataBid = Object.keys(updatedBidSchema[0]);
  const bodyDataBid = updatedBidSchema.map((bid) => Object.values(bid));

  return (
    <div className="bg-white flex w-full">
      <div className="w-full">
        <div className="bg-white mx-8 rounded-3xl justify-center">
          <CustomTable
            data={bodyDataBid}
            headerData={headerDataBid}
            schemaType="BidSchema"
          />
        </div>
        <div className="w-full flex flex-col mt-2 mb-10 gap-y-2">
          <div className="w-11/12 flex justify-end text-[13px] font-normal">
            <h3>
              Amount ={" "}
              {`$ ${
                orderPayments
                  ? amount?.toFixed(2)
                  : formatBalance(numberOfCredits * bidPrice)
              }`}
            </h3>
          </div>
          <div className="w-11/12 flex justify-end text-[13px] font-normal">
            <h3>
              Platform Fee ={" "}
              {`$ ${
                orderPayments
                  ?  platformFee?.toFixed(2)
                  : formatBalance(numberOfCredits * bidPrice * 0.1)
              }`}
            </h3>
          </div>

          <div className="w-11/12 flex justify-end text-[13px] font-normal">
            <h3>
              Taxes (GST) ={" "}
              {`$ ${
                orderPayments
                  ? gst?.toFixed(2)
                  : formatBalance(numberOfCredits * bidPrice * 0.18)
              }`}
            </h3>
          </div>

          <div className="w-11/12 flex justify-end text-[13px] font-normal">
            <h3>
              Remittance ={" "}
              {`$ ${
                orderPayments
                  ? remittance?.toFixed(2)
                  : formatBalance(numberOfCredits * bidPrice * 0.1)
              } `}
            </h3>
          </div>

          <div className="w-11/12 flex justify-end text-[18px] font-bold">
            <h3>
              Total Fund Required ={" "}
              {`$ ${
                orderPayments
                  ? totalAmount?.toFixed(2)
                  : formatBalance(
                      numberOfCredits * bidPrice +
                        numberOfCredits * bidPrice * 0.1 +
                        numberOfCredits * bidPrice * 0.1 +
                        numberOfCredits * bidPrice * 0.18
                    )
              }`}
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bid;
